import { createStyles } from '@zn-material-ui'

export default createStyles({
  spinner: {
    marginLeft: 5,
  },
  forbidEvents: {
    pointerEvents: 'none',
  },
})
